((d, w) => {
	d.addEventListener('DOMContentLoaded', () => {
		const form = d.getElementById('generator-form');
		const statusBox = d.getElementById('status-container');
		const resultBox = d.getElementById('result-container');
		const openingHeader = d.getElementById('opening-header');
		const imgEl = d.getElementById('result-image');
		const dlBtn = d.getElementById('download-btn');
		const tryAgain = d.getElementById('try-again-btn');
		const errorRetry = d.getElementById('try-failed-btn');


		// Editor controls
		const subjX = d.getElementById('adj-subj-x');
		const subjY = d.getElementById('adj-subj-y');
		const subjSize = d.getElementById('adj-subj-size');
		const subjLuma = d.getElementById('adj-luma');

		const subjXOut = d.getElementById('adj-subj-x-out');
		const subjYOut = d.getElementById('adj-subj-y-out');
		const subjSizeOut = d.getElementById('adj-subj-size-out');
		const subjLumaOut = d.getElementById('adj-luma-out');
		
		const applyBtn = d.getElementById('apply-edits');
		const resetBtn = d.getElementById('reset-edits');

		const photoInput = d.getElementById('photo');
		const openCamBtn = d.getElementById('open-camera');
		const camSheet   = d.getElementById('camera-sheet');
		const camVideo   = d.getElementById('cam-video');
		const camCanvas  = d.getElementById('cam-canvas');
		const camTake    = d.getElementById('cam-take');
		const camPreview = d.getElementById('cam-preview');
		const flipBtn    = d.getElementById('flip-camera');
		const snapBtn    = d.getElementById('take-photo');
		const cancelBtn  = d.getElementById('cancel-camera');
		const acceptWrap = d.getElementById('camera-accept');
		const useBtn     = d.getElementById('use-photo');
		const retakeBtn  = d.getElementById('retake-photo');
		const thumbnail  = d.getElementById('small-preview'); 

		let camStream = null;
		let usingBack = false;
		let cameraFile = null;


		const fileInput = d.querySelector('input[name="photo"]') || d.getElementById('photo');

		let currentJobId = null;
		let pollTimer = null;
		const pollAbort = null;

		const NO_CACHE = {
			cache: 'no-store',
			headers: {
				'Cache-Control': 'no-cache, no-store, must-revalidate',
				Pragma: 'no-cache',
				Expires: '0'
			}
		};

		const bust = (url) => url + (url.includes('?') ? '&' : '?') + '_=' + Date.now();

		const setHidden = (el, yes) => el.classList.toggle('hidden', !!yes);

		function triggerEvent(e,params) {
			let dataLayer = window.dataLayer || [];
			let eventData = {
				"event" : e
			}
			if (params) {
				eventData = {...eventData, ...params}
			}
			dataLayer.push(eventData);
		}

		function toast(msg, retain = false, forceTimeout = 2000, takeOver = false) {
			const elem = document.createElement('div');
			elem.classList.add('toast-item');
			if (takeOver) {
				elem.classList.add('toast-takeover');
			}

			const toasts = document.querySelectorAll('.toast-item').length;

			const t = (toasts > 0 ? document.querySelector('.toast-item') : elem);

			if (toasts > 0) {
				t.innerHTML = _farlo.helpers.strings.escapeUnsafe(msg);
			} else {
				t.append(_farlo.helpers.strings.escapeUnsafe(msg));
				document.getElementsByTagName('body')[0].appendChild(t);
			}
			setTimeout(function () {
				t.classList.add('toast-visible');
			}, 100);

			if (!retain) {
				setTimeout(function () {
					Promise.resolve()
						.then(() => new Promise((resolve) => {
							t.style.animation = 'fadeOut 500ms forwards';
							t.addEventListener('animationend', resolve);
						}))
						.then(() => t.remove());
				}, forceTimeout);
			}
		}


		function showLoader(state, msg) {
			if (state) {
				document.querySelector(".site-generator-card").classList.add("loading");
			} else {
				document.querySelector(".site-generator-card").classList.remove("loading");
			}
			if (msg) {
				toast(msg);
			}

		}

		function validateEmail(val) {
			const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(val);
		}

		async function startCamera() {
			try {
				const constraints = {
				video: { facingMode: usingBack ? { exact: 'environment' } : 'user' },
				audio: false
				};
				camStream = await navigator.mediaDevices.getUserMedia(constraints);
				camVideo.srcObject = camStream;
				await camVideo.play();
				camSheet.classList.remove('hidden');
				window.scrollTo({
					top: camSheet.offsetTop,
					left: 0,
					behavior: "smooth",
				});
				acceptWrap.classList.add('hidden');
				camPreview.classList.add('hidden');
				camCanvas.classList.add('hidden');
				cameraFile = null; // reset
			} catch (e) {
				alert('Could not access camera. You can still upload from your gallery.');
			}
		}
		function stopCamera() {
			if (camStream) {
				camStream.getTracks().forEach(t => t.stop());
				camStream = null;
			}
			camSheet.classList.add('hidden');
		}
		function takeSnapshot() {
			const v = camVideo;
			const w = v.videoWidth;
			const h = v.videoHeight;
			if (!w || !h) return;
			// Limit to ~1800px max side (matches your shrinker nicely)
			const MAX_SIDE = 1800;
			const scale = Math.min(1, MAX_SIDE / Math.max(w, h));
			camCanvas.width  = Math.max(1, Math.round(w * scale));
			camCanvas.height = Math.max(1, Math.round(h * scale));
			const ctx = camCanvas.getContext('2d', { willReadFrequently: true });
			ctx.imageSmoothingQuality = 'high';
			ctx.drawImage(v, 0, 0, camCanvas.width, camCanvas.height);

			camCanvas.toBlob(async (blob) => {
				if (!blob) {
				// fallback via dataURL
				const dataURL = camCanvas.toDataURL('image/jpeg', 0.92);
				const bin = atob(dataURL.split(',')[1]);
				const u8 = new Uint8Array(bin.length);
				for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
				blob = new Blob([u8], { type: 'image/jpeg' });
				}
				cameraFile = new File([blob], 'camera.jpg', { type: 'image/jpeg' });
				camPreview.src = URL.createObjectURL(blob);
				camPreview.classList.remove('hidden');
				acceptWrap.classList.remove('hidden');
				
				camTake.classList.add('hidden');
				camVideo.classList.add('hidden');

				camCanvas.classList.add('hidden'); 
				triggerEvent("picture_taken");
			}, 'image/jpeg', 0.92);
		}
		function revokePreview() {
			if (camPreview.src) {
				URL.revokeObjectURL(camPreview.src);
				camPreview.removeAttribute('src');
			}
		}

		function setSlider(range, out, value, fmt = (v) => v) {
			range.value = String(value);
			out.textContent = fmt(range.value);
			range.dispatchEvent(new Event('input', { bubbles: true }));
		}
				
		function bindOut(range, out, fmt = (v) => v) {
		if (!range || !out) return;
		out.textContent = fmt(range.value);
		range.addEventListener('input', () => (out.textContent = fmt(range.value)));
		}
		bindOut(subjX, subjXOut);
		bindOut(subjY, subjYOut);
		bindOut(subjSize, subjSizeOut, (v) => `${v}%`);
		bindOut(subjLuma, subjLumaOut);


		let shrinking = false;

		function shrinkFileIfNeeded(file, MAX_SIDE = 1800, QUALITY = 0.80) {
			return new Promise(async (resolve) => {
			// If already small (<5MB), skip.
				if (!file || file.size < 5 * 1024 * 1024) {
					return resolve(file);
				}

				const blobUrl = URL.createObjectURL(file);
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

				async function drawViaBitmap() {
					// Safari 17 supports createImageBitmap for many formats; HEIC may still fail.
					const bmp = await createImageBitmap(file).catch(() => null);
					if (!bmp) {
						return false;
					}
					const scale = Math.min(1, MAX_SIDE / Math.max(bmp.width, bmp.height));
					canvas.width = Math.max(1, Math.round(bmp.width * scale));
					canvas.height = Math.max(1, Math.round(bmp.height * scale));
					ctx.imageSmoothingQuality = 'high';
					ctx.drawImage(bmp, 0, 0, canvas.width, canvas.height);
					return true;
				}

				async function drawViaImage() {
					return new Promise((res) => {
						const img = new Image();
						img.onload = () => {
							const scale = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight));
							canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
							canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
							ctx.imageSmoothingQuality = 'high';
							ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
							res(true);
						};
						img.onerror = () => res(false);
						img.src = blobUrl; // some iOS builds won’t decode HEIC here; that’s OK
					});
				}

				shrinking = true;
				let drawn = await drawViaBitmap();
				if (!drawn) {
					drawn = await drawViaImage();
				}

				let out = file; // default to original if all else fails
				if (drawn) {
					let dataURL = canvas.toDataURL('image/jpeg', QUALITY);
					if (!/^data:image\/jpeg/.test(dataURL)) {
						// fallback
						dataURL = canvas.toDataURL('image/png');
					}
					const [hdr, b64] = dataURL.split(',');
					const bin = atob(b64);
					const u8 = new Uint8Array(bin.length);
					for (let i = 0; i < bin.length; i ++) {
						u8[ i ] = bin.charCodeAt(i);
					}
					const nameBase = (file.name && file.name.replace(/\.[^.]+$/, '')) || 'photo';
					out = new File([u8], `${ nameBase }.jpg`, { type: 'image/jpeg' });
				}

				URL.revokeObjectURL(blobUrl);
				shrinking = false;
				resolve(out);
			});
		}


        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            // Hide the form and show the status area immediately
			setHidden(openingHeader, true);
            setHidden(form, true);
            setHidden(statusBox, false);
            statusBox.querySelector('p').textContent = 'Uploading...';
            try {
                const fd = new FormData();
                const fNameInput = form.elements['fname'];
                fd.append('fname', fNameInput ? fNameInput.value.trim() : '');
				
				const lNameInput = form.elements['lname'];
                fd.append('lname', lNameInput ? lNameInput.value.trim() : '');

				const emailInput = form.elements['email'];
				const emailAddress = emailInput ? emailInput.value.trim() : '';
				if (!validateEmail(emailAddress)) {
					return;
				}
				fd.append('email', emailAddress )
				fd.append('nonce', window.nonce);

                const districtInput = form.elements['district_number'];
                fd.append('district_number', districtInput && districtInput.value);
                // Determine size selection
                let sizeVal = 'lg';
                const sizeControl = form.elements['size'];
                if (sizeControl && sizeControl.length) {
                    for (const r of sizeControl) {
                        if (r.checked) { sizeVal = r.value; break; }
                    }
                } else if (sizeControl && sizeControl.value) {
                    sizeVal = sizeControl.value;
                }
                fd.append('size', sizeVal);


                // Process the photo
                const picked = (fileInput && fileInput.files && fileInput.files[0]) || null;
				let fileToSend = null;

				if (cameraFile) {
				// Photo taken in-app
				fileToSend = cameraFile;
				} else if (picked) {
				// Gallery upload
				const shrunk = await shrinkFileIfNeeded(picked, 1800, 0.80);
				fileToSend = shrunk || picked;
				}

				if (fileToSend) {	
					fd.append('photo', fileToSend);	
				}

                const res = await fetch(bust('submit_job.php'), { method: 'POST', body: fd, ...NO_CACHE });
                const data = await res.json();
                if (!data || data.status !== 'success') {
					triggerEvent("selfie_generation_failed");
					document.querySelector(".status-container__message").classList.add("hidden");
					setHidden(errorRetry,false);
                    throw new Error((data && data.message) || 'Failed to submit');
                }
                currentJobId = data.job_id;
                statusBox.querySelector('p').textContent = 'Processing your image...';
                startPolling(currentJobId);
            } catch (err) {
                statusBox.querySelector('p').textContent = 'Error: ' + ((err && err.message) || err);
				document.querySelector(".status-container__message").classList.add("hidden");
				setHidden(errorRetry,false);
                setHidden(tryAgain, false);
            }
        });

		function startPolling(id) {
			if (pollTimer) {
				clearInterval(pollTimer);
			}

			let attempt = 0;
			const startedAt = Date.now();
			const HARD_TIMEOUT_MS = 90_000;

			async function tick() {
				if (Date.now() - startedAt > HARD_TIMEOUT_MS) {
					clearInterval(pollTimer);
					statusBox.querySelector('p').textContent = 'Still processing… please try again.';
					setHidden(tryAgain, false);
					return;
				}

				attempt ++;
				try {
                const res = await fetch(
                    bust(`get_job.php?job_id=${ encodeURIComponent(id) }`),
                    {
                        cache: 'no-store',
                        headers: {
                            'Accept': 'application/json',
                            'Cache-Control': 'no-cache, no-store, must-revalidate',
                            Pragma: 'no-cache',
                            Expires: '0'
                        }
                    }
                );

					if (!res.ok) {
						return;
					} // retry on next tick

					// Prefer native JSON parse (handles BOM etc.)
					let data;
					try {
						data = await res.json();
					} catch {
						// Fallback: text->JSON in case a proxy injects stray bytes
						const txt = await res.text();
						try {
							data = JSON.parse(txt);
						} catch {
							return;
						}
					}

					if (!data || !data.status) {
						return;
					}

					if (data.status === 'complete') {
						clearInterval(pollTimer);
						triggerEvent("selfie_generated", {
							"district" : document.getElementById("district_number").value
						});

						// Some CDNs can delay the final_file propagation by a second.
						// If missing, fall back to the well-known path.
						const rel = data.final_file && String(data.final_file).trim()
							? data.final_file
							: `/results/${ id }.jpg`;
						showResult(rel);
					} else if (data.status === 'failed') {
						clearInterval(pollTimer);
						statusBox.querySelector('p').textContent = 'Error: ' + (data.error_message || 'Unknown');
						setHidden(tryAgain, false);
						setHidden(errorRetry,false);
					}
				} catch {
					// ignore transient errors; next tick will retry
				}
			}

			tick(); // immediate
			pollTimer = setInterval(() => {
				if (attempt < 50) {
					tick();
				} else if (attempt % 2 === 0) {
					tick();
				} else if (attempt % 3 === 0) {
					tick();
				}
			}, 1500);
		}

		function makeSafeFilenameBase(str, { ascii = true, maxLen = 60 } = {}) {
			let s = (str || '').trim();

			if (ascii) {
				s = s.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
			}
			s = s.replace(/\s+/g, ' ');
			s = s.replace(/[<>:"/\\|?*\x00-\x1F]/g, '');
			s = s.replace(/[\/\\]/g, '');
			s = s.replace(/\s+/g, '-');
			s = s.replace(/^[.\-]+|[.\-]+$/g, '');
			const reserved = /^(con|prn|aux|nul|com[1-9]|lpt[1-9])$/i;
			if (reserved.test(s)) s = '_' + s;

			if (s.length > maxLen) s = s.slice(0, maxLen);

			if (!s) s = '';

			return '-' + s;
		}

		function showResult(relUrl) {
			setHidden(statusBox, true);
			showLoader(false);
			setHidden(resultBox, false);

			const path = '/' + String(relUrl).replace(/^\/+/, '');
			const src = bust(path);

			imgEl.dataset.jobId = currentJobId;
			imgEl.onload = null; 
			imgEl.onerror = null;

			let tries = 0;
			imgEl.onerror = () => {
				if (tries ++ < 3) {
					setTimeout(() => {
						imgEl.src = bust(path);
					}, 700);
				}
			};

			imgEl.src = src;
			dlBtn.href = src;
			dlBtn.download = `panem-citizen${makeSafeFilenameBase(fNameInput.value.toLowerCase().trim())}${makeSafeFilenameBase(fNameInput.value.toLowerCase().trim())}.jpg`; 
			const panel = document.getElementById('editor-panel');
			if (panel && !panel.classList.contains('is-open')) {
				panel.classList.add('is-open');
				document.body.classList.add('has-editor-open');
				panel.addEventListener('click', (e) => {
					const rect = panel.getBoundingClientRect();
					if (e.clientY - rect.top < 24) {
						panel.classList.toggle('is-open');
						document.body.classList.toggle('has-editor-open', panel.classList.contains('is-open'));
					}
				}, { once: true });
			}
		}

		openCamBtn?.addEventListener('click', startCamera);
		cancelBtn?.addEventListener('click', () => { revokePreview(); stopCamera(); });
		flipBtn?.addEventListener('click', async () => {
			usingBack = !usingBack;
			stopCamera();
			await startCamera();
		});
		snapBtn?.addEventListener('click', takeSnapshot);
		retakeBtn?.addEventListener('click', () => {
			revokePreview();
			acceptWrap.classList.add('hidden');
			camPreview.classList.add('hidden');
			camTake.classList.remove('hidden');
			camVideo.classList.remove('hidden');
		});
		useBtn?.addEventListener('click', () => {
			photoInput.removeAttribute("required");
			photoInput.classList.add('hidden');
			openCamBtn.classList.add('hidden');
			thumbnail.src = camPreview.src;
			thumbnail.classList.remove('hidden');
			stopCamera();
		});
		thumbnail?.addEventListener('click', () => {
			thumbnail.classList.add('hidden');
			camSheet.classList.remove('hidden');

		})
		tryAgain?.addEventListener('click', () => {
			if (pollTimer) {
				clearInterval(pollTimer);
			}
			if (pollAbort) {
				pollAbort.abort();
			}
			setHidden(resultBox, true);
			setHidden(statusBox, true);
			setHidden(form, false);
			form.reset();
			currentJobId = null;
		});
		errorRetry?.addEventListener('click', () => {
			if (pollTimer) {
				clearInterval(pollTimer);
			}
			if (pollAbort) {
				pollAbort.abort();
			}
			setHidden(resultBox, true);
			setHidden(statusBox, true);
			setHidden(form, false);
			form.reset();
			currentJobId = null;
		});

		async function apply(reset = false) {
			if (!currentJobId) return;

			// setHidden(statusBox, false);
			// statusBox.querySelector('p').textContent = reset ? 'Resetting…' : 'Updating…';
			showLoader(true);

			const body = new FormData();
			body.append('job_id', currentJobId);

			if (reset) {
				body.append('reset', '1'); // server will NULL out the fields
				setSlider(subjX,subjXOut,0);
				setSlider(subjY,subjYOut,0);
				setSlider(subjSize,subjSizeOut,100);
				setSlider(subjLuma,subjLumaOut,0);
			} else {
				// Clamp on client (server will clamp again)
				const x = Math.max(-2000, Math.min(2000, parseInt(subjX.value || '0', 10)));
				const y = Math.max(-2000, Math.min(2000, parseInt(subjY.value || '0', 10)));
				const size = Math.max(10, Math.min(400, parseInt(subjSize.value || '100', 10)));
				const luma = Math.max(0, Math.min(1, parseFloat(subjLuma.value || '0')));

				body.append('subject_offset_x', String(x));
				body.append('subject_offset_y', String(y));
				body.append('subject_scale_pct', String(size));
				body.append('subject_luma_strength', String(luma));
			}

			const res = await fetch(bust('update_job.php'), { method: 'POST', body, ...NO_CACHE });
			const data = await res.json();
			if (data.status !== 'success') {
				showLoader(false, 'Update failed');
				console.log('Error: ' + (data.message || 'Update failed'));
				setHidden(errorRetry,false);
				return;
			}
			startPolling(currentJobId);
		}

		applyBtn?.addEventListener('click', () => apply(false));
		resetBtn?.addEventListener('click', () => apply(true));
	});

	w.addEventListener('load', () => d.body.classList.add('loaded'));
})(document, window);